import { IPractice } from '@principle-theorem/principle-core/interfaces';
import {
  DocumentReference,
  Firestore,
  IQueryBuilder,
  ITimestampRange,
  Query,
  WithRef,
} from '@principle-theorem/shared';
import { BigQueryJobName } from '../job-names';

export interface IBigQuerySyncRequest {
  practiceRef: DocumentReference<IPractice>;
  range: ITimestampRange;
  requestsPerMinute?: number;
}

export interface IBigQuerySyncHandler<Record, TopicData> {
  bigQueryJobName: BigQueryJobName;

  resolveItems(request: IBigQuerySyncRequest): Promise<WithRef<Record>[]>;

  getTopicData(
    item: WithRef<Record>,
    request: IBigQuerySyncRequest
  ): Promise<TopicData>;
}

export abstract class BasicBigQuerySyncHandler<Record extends object, TopicData>
  implements
    IBigQuerySyncHandler<Record, TopicData>,
    IQueryBuilder<IBigQuerySyncRequest, Record>
{
  abstract bigQueryJobName: BigQueryJobName;

  abstract getQuery(data: IBigQuerySyncRequest): Query<Record>;

  abstract getTopicData(
    item: WithRef<Record>,
    request: IBigQuerySyncRequest
  ): Promise<TopicData>;

  resolveItems(request: IBigQuerySyncRequest): Promise<WithRef<Record>[]> {
    return Firestore.getDocs<Record>(this.getQuery(request));
  }
}
